(function () {
  function getRoot(element) {
    return element.closest(".lnox-calc-wrapper") || document.querySelector(".lnox-calc-wrapper");
  }

  function getNumber(root, selector) {
    const input = root.querySelector(selector);
    if (!input || input.value.trim() === "") return null;

    const value = parseFloat(String(input.value).replace(",", "."));
    return isNaN(value) ? null : value;
  }

  function formatEuro(value) {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR"
    }).format(value);
  }

  function formatKwh(value) {
    return new Intl.NumberFormat("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value) + " kWh";
  }

  function calculateDevice(watt, hours, days, priceCent) {
    const kwhPerDay = (watt / 1000) * hours;
    const kwhPerMonth = kwhPerDay * days;
    const costPerDay = kwhPerDay * (priceCent / 100);
    const costPerMonth = kwhPerMonth * (priceCent / 100);
    const costPerSummer = costPerDay * 90;

    return {
      kwhPerDay,
      kwhPerMonth,
      costPerDay,
      costPerMonth,
      costPerSummer
    };
  }

  function createResultCard(title, data) {
    return ''
      + '<div class="lnox-result-card">'
      + '<h3>' + title + '</h3>'
      + '<div class="lnox-result-number">' + formatEuro(data.costPerMonth) + '</div>'
      + '<p class="lnox-result-muted">geschätzte Stromkosten pro Monat</p>'
      + '<p><strong>Verbrauch pro Tag:</strong> ' + formatKwh(data.kwhPerDay) + '</p>'
      + '<p><strong>Verbrauch pro Monat:</strong> ' + formatKwh(data.kwhPerMonth) + '</p>'
      + '<p><strong>Kosten pro Tag:</strong> ' + formatEuro(data.costPerDay) + '</p>'
      + '<p><strong>Kosten für 90 Sommertage:</strong> ' + formatEuro(data.costPerSummer) + '</p>'
      + '</div>';
  }

  function calculate(root) {
    if (!root) return;

    const resultBox = root.querySelector("#resultBox");
    if (!resultBox) return;

    const fanWatt = getNumber(root, "#fanWatt");
    const acWatt = getNumber(root, "#acWatt");
    const priceCent = getNumber(root, "#electricityPrice");
    const hours = getNumber(root, "#hoursPerDay");
    const days = getNumber(root, "#daysPerMonth");

    if (priceCent === null || priceCent <= 0 || hours === null || hours <= 0 || days === null || days <= 0) {
      resultBox.innerHTML = ''
        + '<h2>Bitte Werte prüfen</h2>'
        + '<p>Strompreis, Nutzungsdauer und Nutzungstage müssen sinnvoll ausgefüllt sein.</p>';
      return;
    }

    const hasFan = fanWatt !== null && fanWatt > 0;
    const hasAc = acWatt !== null && acWatt > 0;

    if (!hasFan && !hasAc) {
      resultBox.innerHTML = ''
        + '<h2>Ihr Ergebnis</h2>'
        + '<p>Tragen Sie mindestens die Wattzahl eines Geräts ein. Sie können nur den Deckenventilator, nur das Klimagerät oder beide Geräte berechnen.</p>';
      return;
    }

    let html = '<h2>Ihr Ergebnis</h2>';

    if (hasFan && !hasAc) {
      const fan = calculateDevice(fanWatt, hours, days, priceCent);

      html += ''
        + '<p>Ihr Deckenventilator kostet bei den eingegebenen Werten ungefähr <strong>' + formatEuro(fan.costPerMonth) + ' pro Monat</strong>.</p>'
        + '<div class="lnox-result-grid">'
        + createResultCard("Deckenventilator", fan)
        + '</div>';
    }

    if (!hasFan && hasAc) {
      const ac = calculateDevice(acWatt, hours, days, priceCent);

      html += ''
        + '<p>Ihr Klimagerät kostet bei den eingegebenen Werten ungefähr <strong>' + formatEuro(ac.costPerMonth) + ' pro Monat</strong>.</p>'
        + '<div class="lnox-result-grid">'
        + createResultCard("Klimagerät", ac)
        + '</div>';
    }

    if (hasFan && hasAc) {
      const fan = calculateDevice(fanWatt, hours, days, priceCent);
      const ac = calculateDevice(acWatt, hours, days, priceCent);
      const saving = ac.costPerMonth - fan.costPerMonth;
      const savingSummer = ac.costPerSummer - fan.costPerSummer;

      html += ''
        + '<p>Hier sehen Sie den direkten Vergleich zwischen Deckenventilator und Klimagerät.</p>'
        + '<div class="lnox-result-grid">'
        + createResultCard("Deckenventilator", fan)
        + createResultCard("Klimagerät", ac)
        + '</div>'
        + '<div class="lnox-saving">'
        + 'In diesem Beispiel spart der Deckenventilator gegenüber dem Klimagerät ca. ' + formatEuro(saving) + ' pro Monat und ca. ' + formatEuro(savingSummer) + ' über 90 Sommertage.'
        + '</div>'
        + '<p style="margin-top:16px;">'
        + 'Wichtig: Ein Deckenventilator ersetzt keine echte Klimaanlage. Er kühlt den Raum nicht aktiv herunter, kann aber durch Luftbewegung für ein deutlich angenehmeres Raumgefühl sorgen – bei erheblich geringerem Stromverbrauch.'
        + '</p>';
    }

    resultBox.innerHTML = html;
  }

  function resetCalculator(root) {
    if (!root) return;

    const fanWattInput = root.querySelector("#fanWatt");
    const acWattInput = root.querySelector("#acWatt");
    const priceInput = root.querySelector("#electricityPrice");
    const hoursInput = root.querySelector("#hoursPerDay");
    const daysInput = root.querySelector("#daysPerMonth");
    const resultBox = root.querySelector("#resultBox");

    if (fanWattInput) fanWattInput.value = "";
    if (acWattInput) acWattInput.value = "";
    if (priceInput) priceInput.value = "32";
    if (hoursInput) hoursInput.value = "8";
    if (daysInput) daysInput.value = "30";

    if (resultBox) {
      resultBox.innerHTML = ''
        + '<h2>Ihr Ergebnis</h2>'
        + '<p>Tragen Sie mindestens die Wattzahl eines Geräts ein, um die Stromkosten zu berechnen.</p>';
    }
  }

  document.addEventListener("click", function (event) {
    const calculateButton = event.target.closest("#calculateBtn");
    const resetButton = event.target.closest("#resetBtn");
    const presetButton = event.target.closest(".lnox-preset");

    if (calculateButton) {
      event.preventDefault();
      calculate(getRoot(calculateButton));
      return;
    }

    if (resetButton) {
      event.preventDefault();
      resetCalculator(getRoot(resetButton));
      return;
    }

    if (presetButton) {
      event.preventDefault();

      const root = getRoot(presetButton);
      if (!root) return;

      const text = presetButton.textContent || "";

      if (text.includes("25")) {
        const fanInput = root.querySelector("#fanWatt");
        if (fanInput) fanInput.value = "25";
      }

      if (text.includes("1.000") || text.includes("1000")) {
        const acInput = root.querySelector("#acWatt");
        if (acInput) acInput.value = "1000";
      }

      calculate(root);
    }
  });

  document.addEventListener("input", function (event) {
    if (
      event.target.matches("#fanWatt") ||
      event.target.matches("#acWatt") ||
      event.target.matches("#electricityPrice") ||
      event.target.matches("#hoursPerDay") ||
      event.target.matches("#daysPerMonth")
    ) {
      calculate(getRoot(event.target));
    }
  });
})();